/**
 * main.tsx — Application entry point
 *
 * Mounts the App root component (which switches between LoginView,
 * AdminDashboard, and OnlineJobSheetPage) into the #root div.
 * CDN assets (jsPDF, Phosphor Icons, Tailwind) are loaded via index.html.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import the original CSS files so Vite bundles them alongside the JS.
// input.css is the Tailwind v4 entry point (@import "tailwindcss" + @theme
// brand tokens) — required for every utility class used across the app.
// admin_dashboard.css holds the extra custom rules/animations layered on top.
// online_job_sheet.css holds the driver page's premium purple/gold theme
// (header-gradient, gold-line, logo-ring, plate-chip, btn-complete-glow,
// timeline dots, modal-open body-scroll lock, #signature-canvas touch-action) —
// required for OnlineJobSheetPage to render correctly.
import './input.css';
import './admin_dashboard.css';
import './online_job_sheet.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
